export const FontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};
